
export namespace PageCs {
  export const DATA_CONTENT = 'content';
  export const TOTAL_PAGES = 'totalPages';
  export const TOTAL_ITEMS = 'totalElements';
}
